<template>
  <div>
    <product-form v-if="product"
      @submit="submit"
      @addComment="addComment"
      :init-product="product"
      :custom-categories="customCategories"
      :product-custom-categories="productCustomCategories"
      :val-errors="valErrors"
      submit-text="Speichern"
      :uploading="uploading"
    />
    <add-instance-dialog
      :show="showAddInstanceDialog"
      @addInstance="addInstance"
      @close="closeAddInstanceDialog"
      :val-errors="instanceErrors"
    />
  </div>
</template>

<script>
import ProductForm from './../product-form'
import moment from 'moment'
import AddInstanceDialog from './../add-instance-dialog'
import showLabelsAlert from 'src/productInstancesLabelsAlert'

export default {
  components: {
    ProductForm,
    AddInstanceDialog
  },
  data () {
    return {
      product: null,
      customCategories: [],
      productCustomCategories: {},
      valErrors: [],
      uploading: false,
      showAddInstanceDialog: false,
      createdVariation: null,
      instanceErrors: []
    }
  },
  methods: {
    async submit (product) {
      await this.initCsrf()

      this.valErrors = []
      this.$http.post(`/products/${this.product.id}/variations`, product).then(({ data }) => {
        this.$notify({
          message: 'Variation erfolgreich erstellt.',
          type: 'success'
        })
        this.createdVariation = data
        this.showAddInstanceDialog = true
      }).catch(({ response }) => { this.valErrors = response.data.errors })
    },
    addComment (comment) {
      this.product.info_highlights.unshift({
        comment,
        user: this.$store.state.authUser,
        created_at: moment()
      })
    },
    async addInstance (reqData) {
      await this.initCsrf()

      const url = `/products/${this.createdVariation.id}/instances`
      this.$http.post(url, reqData).then(({ data }) => {
        // does also call closeAddInstanceDialog, dunno why tho
        this.showAddInstanceDialog = false
        this.$notify({
          message: 'Die Instanzierung wurden erfolgreich erfasst.',
          type: 'success'
        })
        showLabelsAlert(data)
      }).catch(({ response }) => { this.instanceErrors = response.data.errors })
    },
    closeAddInstanceDialog () {
      this.showAddInstanceDialog = false
      this.$router.push(`/products/${this.createdVariation.id}`)
    }
  },
  created () {
    this.$http.get(`/products/${this.$route.params.id}`).then(({ data }) => {
      data.has_variations = false
      data.is_variation_of = data.id

      const product = data

      product.product_features = product.product_features.reduce((features, feature) => {
        features[feature.custom_category_id] = feature
        return features
      }, {})

      this.$http.get('/custom_categories').then(({ data }) => {
        const customCategories = data.filter(customCategory => product.product_features[customCategory.id])
        this.product = product
        this.customCategories = customCategories
      })
    })
  }
}
</script>
